/** See `src/i18n/locales/en/documents.ts`. */
export const documents = {
  page: {
    title: 'Documenten',
    lead: 'Upload en beheer documenten voor {{company}}.',
    noScope: 'Selecteer een bedrijf om de documenten te zien.',
    forbidden: 'Je mag de documenten van dit bedrijf niet zien.',
  },
  upload: {
    title: 'Document uploaden',
    titleField: 'Titel',
    category: 'Categorie',
    audience: 'Doelgroep',
    fileUrl: 'Bestands-URL',
    file: 'Bestand',
    upload_status: {
      uploading: 'Bezig met uploaden…',
      tooLarge: 'Bestand is te groot (max. 10MB).',
      invalidType: 'Bestandstype niet toegestaan.',
    },
    fileUrlHint: 'Wordt direct geüpload; of vul hieronder een bestaande URL in.',
    requiresReadConfirmation: 'Leesbevestiging vereist',
    requiresReadConfirmationHint:
      'Medewerkers moeten bevestigen dat ze dit document hebben gelezen.',
    submit: 'Uploaden',
  },
  categories: {
    algemeen: 'Algemeen',
    beleid: 'Beleid',
    veiligheid: 'Veiligheid',
    hr: 'HR',
    vitaliteit: 'Vitaliteit',
  },
  audiences: {
    iedereen: 'Iedereen',
    management: 'Management',
    per_afdeling: 'Per afdeling',
    per_locatie: 'Per locatie',
  },
  status: {
    gepubliceerd: 'Gepubliceerd',
    archief: 'Archief',
  },
  library: {
    title: 'Documentenbibliotheek',
    empty: 'Nog geen documenten.',
    totalViews: 'Totaal aantal weergaven: {{count}}',
    columns: {
      title: 'Titel',
      category: 'Categorie',
      views: 'Weergaven',
      status: 'Status',
    },
  },
  actions: {
    new: 'Document uploaden',
    cancel: 'Annuleren',
    publish: 'Publiceren',
    archive: 'Archiveren',
  },
} as const;
